import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { value: null }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { value: null }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { value: null }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { value: null }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { value: null }
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "mb-3" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { value: null }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "col" }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { value: null }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = { class: "col" }
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { value: null }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col" }
const _hoisted_75 = { class: "mb-3" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { value: null }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "mb-3" }
const _hoisted_80 = { class: "form-check" }
const _hoisted_81 = { class: "form-check" }
const _hoisted_82 = { class: "col" }
const _hoisted_83 = { class: "mb-3" }
const _hoisted_84 = { class: "row g-2 mb-3" }
const _hoisted_85 = { class: "col" }
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "col" }
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "col" }
const _hoisted_90 = ["value"]
const _hoisted_91 = { class: "col" }
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "col" }
const _hoisted_94 = ["value"]
const _hoisted_95 = { class: "col" }
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "toml-preview w-100" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Add new Turbine")
      ], -1)),
      _cache[80] || (_cache[80] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("p", null, " Enter all known information about the turbine and blades. The config toml is generated automatically, and upon saving copies the base64 conversion to your clipboard ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.errorMsg)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.errorMsg), 1))
                  : _createCommentVNode("", true),
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "modal-section-title" }, [
                  _createElementVNode("h5", null, "Site config")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, "Country", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.country) = $event)),
                        class: "form-select",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadSitesForCountry && _ctx.loadSitesForCountry(...args)))
                      }, [
                        _cache[35] || (_cache[35] = _createElementVNode("option", { value: null }, "Select country", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: country,
                            key: country
                          }, _toDisplayString(country), 9, _hoisted_11))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.form.country]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Site", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.site_id) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.country
                      }, [
                        _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.form.country ? "Select a site" : "Select country first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: site.site_id,
                            value: site.site_id
                          }, _toDisplayString(site.name), 9, _hoisted_16))
                        }), 128))
                      ], 8, _hoisted_14), [
                        [_vModelSelect, _ctx.form.site_id]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Customer", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.customer_name) = $event)),
                        class: "form-select",
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadCustomerSubgroupsForCustomer && _ctx.loadCustomerSubgroupsForCustomer(...args)))
                      }, [
                        _cache[38] || (_cache[38] = _createElementVNode("option", { value: null }, "Select customer", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerNames, (customerName) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: customerName,
                            value: customerName
                          }, _toDisplayString(customerName), 9, _hoisted_20))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.form.customer_name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Customer subgroup", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.customer_id) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.customer_name
                      }, [
                        _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.form.customer_name ? "Select a customer subgroup" : "Select customer first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerSubgroups, (customer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: customer.customer_id,
                            value: customer.customer_id
                          }, _toDisplayString(Object.values(customer.tags).join(", ")), 9, _hoisted_25))
                        }), 128))
                      ], 8, _hoisted_23), [
                        [_vModelSelect, _ctx.form.customer_id]
                      ])
                    ])
                  ])
                ]),
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "modal-section-title" }, [
                  _createElementVNode("h5", null, "Turbine config")
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label" }, "Turbine name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.turbine_name) = $event)),
                        class: "form-control",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.turbine_name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "form-label" }, "Turbine designer", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.turbine_designer_id) = $event)),
                        class: "form-select",
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.loadTurbineModelsForDesigner && _ctx.loadTurbineModelsForDesigner(...args)))
                      }, [
                        _cache[42] || (_cache[42] = _createElementVNode("option", { value: null }, "Select designer", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: company.company_id,
                            value: company.company_id
                          }, _toDisplayString(company.name), 9, _hoisted_31))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.form.turbine_designer_id]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label" }, "Turbine model", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.turbine_model) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.turbine_designer_id,
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.loadBladeManufacturersForTurbineModel && _ctx.loadBladeManufacturersForTurbineModel(...args)))
                      }, [
                        _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.form.turbine_designer_id ? "Select model" : "Select turbine designer first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.turbineModels, (model) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: model.turbine_model_id,
                            value: model.turbine_model_id
                          }, _toDisplayString(model.model), 9, _hoisted_36))
                        }), 128))
                      ], 40, _hoisted_34), [
                        [_vModelSelect, _ctx.form.turbine_model]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label" }, "Aggregator name", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.aggregator_serial) = $event)),
                        class: "form-select"
                      }, [
                        _cache[45] || (_cache[45] = _createElementVNode("option", { value: null }, "Select aggregator", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aggregators, (agg) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: agg.serial,
                            value: String(agg.serial)
                          }, _toDisplayString(agg.name), 9, _hoisted_39))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.aggregator_serial]
                      ])
                    ])
                  ])
                ]),
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "modal-section-title" }, [
                  _createElementVNode("h5", null, "Blade config")
                ], -1)),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label" }, "Blade A: S/N", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.blade_A_sn) = $event)),
                        class: "form-control",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.blade_A_sn]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label" }, "Blade A: manufacturer", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.blade_A_manufacturer) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.turbine_model,
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadBladeModelsForBlade('A')))
                      }, [
                        _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.form.turbine_model ? "Select manufacturer" : "Select turbine model first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeManufacturers, (manufacturer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: manufacturer,
                            value: manufacturer
                          }, _toDisplayString(manufacturer), 9, _hoisted_47))
                        }), 128))
                      ], 40, _hoisted_45), [
                        [_vModelSelect, _ctx.form.blade_A_manufacturer]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "Blade A: model", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.blade_A_model) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.blade_A_manufacturer
                      }, [
                        _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.form.blade_A_manufacturer ? "Select model" : "Select manufacturer first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeAModels, (model) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: model.blade_model_id,
                            value: model.blade_model_id
                          }, _toDisplayString(model.name), 9, _hoisted_52))
                        }), 128))
                      ], 8, _hoisted_50), [
                        [_vModelSelect, _ctx.form.blade_A_model]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _cache[50] || (_cache[50] = _createElementVNode("label", { class: "form-label" }, "Blade B: S/N", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.blade_B_sn) = $event)),
                        class: "form-control",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.blade_B_sn]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label" }, "Blade B: manufacturer", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.blade_B_manufacturer) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.turbine_model,
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadBladeModelsForBlade('B')))
                      }, [
                        _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.form.turbine_model ? "Select manufacturer" : "Select turbine model first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeManufacturers, (manufacturer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: manufacturer,
                            value: manufacturer
                          }, _toDisplayString(manufacturer), 9, _hoisted_60))
                        }), 128))
                      ], 40, _hoisted_58), [
                        [_vModelSelect, _ctx.form.blade_B_manufacturer]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _cache[52] || (_cache[52] = _createElementVNode("label", { class: "form-label" }, "Blade B: model", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.blade_B_model) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.blade_B_manufacturer
                      }, [
                        _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.form.blade_B_manufacturer ? "Select model" : "Select manufacturer first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeBModels, (model) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: model.blade_model_id,
                            value: model.blade_model_id
                          }, _toDisplayString(model.name), 9, _hoisted_65))
                        }), 128))
                      ], 8, _hoisted_63), [
                        [_vModelSelect, _ctx.form.blade_B_model]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[53] || (_cache[53] = _createElementVNode("label", { class: "form-label" }, "Blade C: S/N", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.blade_C_sn) = $event)),
                        class: "form-control",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.blade_C_sn]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _cache[54] || (_cache[54] = _createElementVNode("label", { class: "form-label" }, "Blade C: manufacturer", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.blade_C_manufacturer) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.turbine_model,
                        onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.loadBladeModelsForBlade('C')))
                      }, [
                        _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.form.turbine_model ? "Select manufacturer" : "Select turbine model first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeManufacturers, (manufacturer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: manufacturer,
                            value: manufacturer
                          }, _toDisplayString(manufacturer), 9, _hoisted_73))
                        }), 128))
                      ], 40, _hoisted_71), [
                        [_vModelSelect, _ctx.form.blade_C_manufacturer]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _cache[55] || (_cache[55] = _createElementVNode("label", { class: "form-label" }, "Blade C: model", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.blade_C_model) = $event)),
                        class: "form-select",
                        disabled: !_ctx.form.blade_C_manufacturer
                      }, [
                        _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.form.blade_C_manufacturer ? "Select model" : "Select manufacturer first"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeCModels, (model) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: model.blade_model_id,
                            value: model.blade_model_id
                          }, _toDisplayString(model.name), 9, _hoisted_78))
                        }), 128))
                      ], 8, _hoisted_76), [
                        [_vModelSelect, _ctx.form.blade_C_model]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _cache[58] || (_cache[58] = _createElementVNode("label", { class: "form-label" }, "Additional components", -1)),
                  _createElementVNode("div", _hoisted_80, [
                    _withDirectives(_createElementVNode("input", {
                      id: "include-drivetrain",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.include_drivetrain) = $event)),
                      class: "form-check-input",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.include_drivetrain]
                    ]),
                    _cache[56] || (_cache[56] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "include-drivetrain"
                    }, "Add drivetrain component", -1))
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _withDirectives(_createElementVNode("input", {
                      id: "include-tower",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.include_tower) = $event)),
                      class: "form-check-input",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.include_tower]
                    ]),
                    _cache[57] || (_cache[57] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "include-tower"
                    }, "Add tower component", -1))
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_82, [
          _cache[76] || (_cache[76] = _createElementVNode("div", { class: "modal-section-title" }, [
            _createElementVNode("h5", null, "Balena config")
          ], -1)),
          _createElementVNode("div", _hoisted_83, [
            _cache[63] || (_cache[63] = _createElementVNode("label", { class: "form-label" }, "Sample rate", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.sampleRate) = $event)),
              class: "form-select w-100"
            }, [...(_cache[62] || (_cache[62] = [
              _createElementVNode("option", { value: 62.5 }, "62.5 Hz", -1),
              _createElementVNode("option", { value: 125 }, "125 Hz", -1),
              _createElementVNode("option", { value: 250 }, "250 Hz", -1),
              _createElementVNode("option", { value: 500 }, "500 Hz", -1),
              _createElementVNode("option", { value: 1000 }, "1000 Hz", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.sampleRate]
            ])
          ]),
          _cache[77] || (_cache[77] = _createElementVNode("div", { class: "modal-section-title" }, [
            _createElementVNode("h5", null, "Node config")
          ], -1)),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _cache[65] || (_cache[65] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 11", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.selectedNode11) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[64] || (_cache[64] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(11), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_86))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode11]
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _cache[67] || (_cache[67] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 12", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedNode12) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[66] || (_cache[66] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(12), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_88))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode12]
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _cache[69] || (_cache[69] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 21", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.selectedNode21) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[68] || (_cache[68] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(21), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_90))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode21]
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _cache[71] || (_cache[71] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 22", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectedNode22) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[70] || (_cache[70] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(22), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_92))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode22]
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _cache[73] || (_cache[73] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 31", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.selectedNode31) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[72] || (_cache[72] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(31), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_94))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode31]
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _cache[75] || (_cache[75] = _createElementVNode("label", { class: "form-label form-label-sm" }, "Node 32", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selectedNode32) = $event)),
                class: "form-select form-select-sm w-100"
              }, [
                _cache[74] || (_cache[74] = _createElementVNode("option", { value: null }, "Select node", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesForAddress(32), (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_hex,
                    value: n.id_hex
                  }, _toDisplayString(n.id_hex) + " (fw: " + _toDisplayString(n.firmware ?? "?") + ") ", 9, _hoisted_96))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNode32]
              ])
            ])
          ]),
          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "form-label" }, "Aggregator config preview", -1)),
          _createElementVNode("pre", _hoisted_97, _toDisplayString(_ctx.tomlPreview), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, "Save")
        ])
      ])
    ])
  ]))
}